/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, ButtonGroup, Button, Grid, Typography } from '@mui/material'
import { Close, Check } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { connect } from 'react-redux'
import * as online from '../../../../appRedux/actions/fuel_request/online'
import IntlMessages from '../../../../util/IntlMessages'
import useStyles from './reached_origin.style'

function ReachedOrigin(props) {
    const anchor = 'bottom'
    const classes = useStyles()

    const operatorRefuelingFunc = async () => {
        await props.operatorRefuelingAction(props.vRequestCode)
        props.reachedOriginFunc()
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.reachedOrigin}
                onClose={() => props.reachedOriginFunc()}
            >
                <Grid className={classes.root}>
                    <Typography className={classes.title} variant="h5">
                        <IntlMessages id="haveYouReachedTheRefuelingPlace" />
                    </Typography>
                    <ButtonGroup variant="text" color="primary" fullWidth>
                        <Button
                            onClick={() => props.reachedOriginFunc()}
                            startIcon={<Close />}>
                            <IntlMessages id="no" />
                        </Button>
                        <LoadingButton
                            onClick={() => operatorRefuelingFunc()}
                            loading={props.loadingBtn}
                            color="secondary"
                            startIcon={<Check />}>
                            <IntlMessages id="yes" />
                        </LoadingButton>
                    </ButtonGroup>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        loadingBtn: state.common.loadingBtn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        operatorRefuelingAction: (code) => dispatch(online.operatorRefuelingAction(code)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReachedOrigin)